<template>
  <div class="tab-content" :class="(!applyStatus.page.tab04.enable)?'app-lock':''">
    <h2 v-if="form.age === ''" class="title">{{t_content('botApp.tab04.noRating')}}</h2>
    <h2
      v-else-if="form.age === '0+'"
      class="title"
    >{{t_content('botApp.tab04.currentRating')}}:{{t_content('botApp.tab04.allAges')}}</h2>
    <h2 v-else class="title">{{t_content('botApp.tab04.currentRating')}}:年齡 {{form.age}}</h2>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" :show-message="false">
      <el-form-item label prop="ratings">
        <table class="rating col3" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <th>{{t_content('botApp.tab04.description')}}&nbsp;</th>
              <th>{{t_content('botApp.tab04.none')}}&nbsp;&nbsp;&nbsp;</th>
              <th>{{t_content('botApp.tab04.mild')}}/{{t_content('botApp.tab04.occasionally')}}&nbsp;</th>
              <th>{{t_content('botApp.tab04.heavy')}}/{{t_content('botApp.tab04.frequent')}}&nbsp;</th>
            </tr>
            <tr-qustion
              v-on:ratingChanged="calcRating"
              :questions="qtype3"
              :ratings="form.ratings"
              ref="tab04_part1"
            ></tr-qustion>
          </tbody>
        </table>
        <table class="rating col2" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <th>&nbsp;</th>
              <th>{{t_content('botApp.tab04.no')}}&nbsp;&nbsp;&nbsp;</th>
              <th>{{t_content('botApp.tab04.yes')}}&nbsp;&nbsp;&nbsp;</th>
            </tr>
            <tr-qustion :questions="qtype2" :ratings="form.ratings" ref="tab04_part2"></tr-qustion>
          </tbody>
        </table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../../../api'
import apiConfig from '../../../api/apiConfig'
import _ from 'lodash'
import TrQustion from './tab04/trqustion'

export default {
    mounted () {
        this.getQuestions()
    },
    data () {
        var required = (rule, value, callback, label) => {
            let vm = this
            let val = vm.currRatings.length
            if (vm.questions.length !== val) {
                const errMsg = label + ' ' + vm.$t('botApp.common.valid.required')
                vm.$store.state.botAppErrMessages.push(errMsg)
                callback(new Error('Please input the data'))
            } else {
                callback()
            }
        }
        let { age, ratings } = this.appInfo
        if (!age) age = ''
        return {
            form: {
                age,
                ratings
            },
            questions: [],
            rules: {
                ratings: [
                    {
                        validator: (rule, value, callback) =>
                            required(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tabLabel.contentrating')
                            ),
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    components: {
        'tr-qustion': TrQustion
    },
    props: ['appInfo', 'applyStatus'],
    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        getQuestions () {
            // const { title, message, status, publishAfterDate } = this
            const apiUri = 'developer/ratings'
            const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }

            api.request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(response => {
                    // this.availableMarkets = this.marketSort(
                    //     response.data.data.payload,
                    //     this.mainMarket
                    // )
                    const langCode = this.$root.$i18n.locale
                    this.questions = this.i18nlabel(
                        response.data.data.payload,
                        langCode
                    )
                })
                .catch(error => {
                    console.log(error)
                })
        },
        i18nlabel (questions, langCode) {
            if (langCode === 'en') {
                langCode = 'zh-CN'
            }
            return _.map(questions, q => {
                let langObj = _.find(q.i18n, l => {
                    return l.langCode === langCode
                })
                q.label = langObj.title
                q.desc = langObj.desc
                q.help = langObj.help
                q.id = q.miboStoreApplicationRatingId
                q.answser = -1
                return q
            })
        },

        calcRating (currOpts) {
            let maxAge = _.chain(currOpts)
                .map('answer')
                .max()
                .value()
            this.form.age = maxAge + '+'
        },
        getDataFromChild () {
            let partIAns = this.$refs.tab04_part1.getDataFromChild()
            let partIIAns = this.$refs.tab04_part2.getDataFromChild()

            var ratingsArray = _.concat(partIAns, partIIAns)
            this.form.ratings = ratingsArray
            return this.form
        }
    },
    computed: {
        qtype3 () {
            return _.filter(this.questions, { group: 1 })
        },
        qtype2 () {
            return _.filter(this.questions, { group: 2 })
        },
        currRatings () {
            let partIAns = this.$refs.tab04_part1.getDataFromChild()
            let partIIAns = this.$refs.tab04_part2.getDataFromChild()

            var ratingsArray = _.concat(partIAns, partIIAns)
            return ratingsArray
        }
    }
}
</script>

<style lang="scss">
.title {
    color: #00b5e2;
}

table.rating {
    tr {
        height: 80px;
        th:first-child {
            width: 40%;
            p {
                color: gray;
            }
        }
        th:not(:first-child) {
            width: 20%;
        }
        td {
            border-bottom: 1px solid #ccc;
            text-align: center;
            background-color: rgba(51, 51, 51, 0.03);
        }
    }
    tr:last-child {
        td {
            border-bottom: none;
        }
    }
    tr:not(:first-child) {
        th {
            padding: 5px 15px;
            text-align: left;
            background-color: rgba(51, 51, 51, 0.03);
        }
    }
    // &.col3 {
    //     th:not(:first-child) {
    //         width: 20%; // 3 cols
    //     }
    // }
    // &.col2 {
    //     th:first-child {
    //         width: 20%; // 2 cols
    //     }
    // }
    h3,
    p {
        margin: 0 0 5px;
    }
    p {
        font-size: 0.9em;
    }
}
</style>
